import request from '@/utils/request'

export function listCourseItem(data) {
  return request({
    url: '/DiaryRecord/ListCourseItem',
    method: 'post',
    data,
  })
}

export function listCourseItemMachine(data) {
  return request({
    url: '/DiaryRecord/ListCourseItemMachine',
    method: 'post',
    data,
  })
}

export function listCourseItemCategory(data) {
  return request({
    url: '/DiaryRecord/ListCourseItemCategory',
    method: 'post',
    data,
  })
}

export function listAerobicItem(data) {
  return request({
    url: '/DiaryRecord/ListAerobicItem',
    method: 'post',
    data,
  })
}

export function listTrainingSetUnit(data) {
  return request({
    url: '/DiaryRecord/ListTrainingSetUnit',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  return request({
    url: '/DiaryRecord/Update',
    method: 'post',
    data,
  })
}
export function getItem(data) {
  return request({
    url: '/DiaryRecord/Get',
    method: 'post',
    data,
  })
}

export function listForChart(data) {
  return request({
    url: '/DiaryRecord/ListForChart',
    method: 'post',
    data,
  })
}

export function fetchList(data) {
  return request({
    url: '/DiaryRecord/List',
    method: 'post',
    data,
  })
}
